import React, { useState, useRef, useEffect } from "react";
import { useLocation } from "react-router";
import { useHistory } from "react-router-dom";
import logo from "../../assets/images/logo.svg";
import coverIcon from "../../assets/images/coverIcon.svg";
import bookIcon from "../../assets/images/bookIcon.svg";
import { PopoverPicker } from "./PopoverPicker";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import {
  Tabs,
  Divider,
  Collapse,
  notification,
  Menu,
  Dropdown,
  Switch,
  Spin,
  Select,
} from "antd";
import { fabric } from "fabric";
import { UserOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import axios from "axios";
import { Logout } from "../Login/Logout";

const { TabPane } = Tabs;
const { Panel } = Collapse;
const { Option } = Select;

var canvasInstances = [];
const Book = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [isPrimaryPage, setIsPrimaryPage] = useState(false);
  const [isSiblingsPage, setIsSiblingsPage] = useState(false);
  const [isThingsPage, setIsThingsPage] = useState(false);
  const [isFoodPage, setIsFoodPage] = useState(false);
  const [isDrinksPage, setIsDrinksPage] = useState(false);
  const [isToysPage, setIsToysPage] = useState(false);
  const [isWatchPage, setIsWatchPage] = useState(false);
  const [isRoomsPage, setIsRoomsPage] = useState(false);
  const [isBedroomPage, setIsBedroomPage] = useState(false);
  const [isLivingPage, setIsLivingPage] = useState(false);
  const [isHomePage, setIsHomePage] = useState(false);
  const [isPlacesPage, setIsPlacesPage] = useState(false);
  const [isFriendsPage, setIsFriendsPage] = useState(false);
  const [isInterestPage, setIsInterestPage] = useState(false);

  const location = useLocation();
  const id = location.pathname.split("/")[2];
  var myPage = "";
  const loadBook = () => {
    setLoading(true);
    axios({
      method: "GET",
      headers: { "Content-Type": "application/json" },
      url: `${process.env.REACT_APP_BASE_URL}mfb/rest/book/book?id=${id}`,
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
      withCredentials: true,
    })
      .then((res) => {
        if (res.status == 200) {
          setLoading(false);
          res.data.pages.forEach(function (item) {
            myPage = JSON.parse(item);
            //console.log("item", myPage.page);
            var canvasContainer = document.getElementById("canvasContainer");
            var newcanvas = document.createElement("canvas");
            canvasContainer.append(newcanvas);
            var fabricCanvasObj = new fabric.Canvas(newcanvas, {
              width: 842,
              height: 595,
              backgroundColor: "#ffffff",
            });
            canvasInstances.push(fabricCanvasObj);
            canvasInstances.forEach(function (current, index) {
              res.data.pages.sort(function (a, b) {
                var a = JSON.parse(a);
                var b = JSON.parse(b);
                return parseInt(a.canvasID) - parseInt(b.canvasID);
              });

              current.loadFromJSON(res.data.pages[index], function () {
                current.renderAll();
              });
              switch (myPage.page) {
                case "primary":
                  setIsPrimaryPage(true);

                  break;
                case "siblings":
                  setIsSiblingsPage(true);
                  break;
                case "things":
                  setIsThingsPage(true);
                  break;
                case "siblings":
                  setIsSiblingsPage(true);
                  break;
                case "things":
                  setIsThingsPage(true);
                  break;
                case "food":
                  setIsFoodPage(true);
                  break;
                case "drinks":
                  setIsDrinksPage(true);
                  break;
                case "toys":
                  setIsToysPage(true);
                  break;
                case "watch":
                  setIsWatchPage(true);
                  break;
                case "rooms":
                  setIsRoomsPage(true);
                  break;
                case "bedroom":
                  setIsBedroomPage(true);
                  break;
                case "living":
                  setIsLivingPage(true);
                  break;
                case "home":
                  setIsHomePage(true);
                  break;
                case "places":
                  setIsPlacesPage(true);
                  break;
                case "friends":
                  setIsFriendsPage(true);
                  break;
                case "interest":
                  setIsInterestPage(true);
                  break;

                default:
                  break;
              }
            });
          });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  useEffect(() => {
    canvasInstances = [];
    loadBook();
  }, []);

  const createCanvas = (checked, page) => {
    console.log(page);
    var canvasContainer = document.getElementById("canvasContainer");
    var newcanvas = document.createElement("canvas");
    if (checked) {
      canvasContainer.append(newcanvas);
      var fabricCanvasObj = new fabric.Canvas(newcanvas, {
        width: 842,
        height: 595,
        backgroundColor: "#ffffff",
        page: page,
      });
      canvasInstances.push(fabricCanvasObj);
      canvasInstances.forEach(function (item) {
        if (item.page === page) {
          item.wrapperEl.scrollIntoView({ behavior: "smooth" });
        }
      });
    } else {
      canvasInstances.forEach(function (item, index, object) {
        if (item.page === page) {
          object.splice(index, 1);
          item.wrapperEl.remove();
        }
      });
    }
  };

  const deleteItem = () => {
    var selectedObjectBook;
    canvasInstances.forEach(function (current) {
      selectedObjectBook = current.getActiveObject();
      selectedObjectBook && current.remove(selectedObjectBook);
      current.discardActiveObject().renderAll();
      console.log(selectedObjectBook);
    });
  };

  const createNewBook = () => {
    history.push("/Dashboard");
  };
  const addBookContent = (
    text,
    page,
    width,
    fontSize,
    fontWeight,
    left,
    top
  ) => {
    canvasInstances.forEach(function (current) {
      if (current.page === page) {
        const converText = new fabric.IText(`${text}`, {
          fontFamily: "Roboto, sans-serif",
          left: left,
          top: top,
          type: "i-text",
          width: width,
          fontSize: fontSize,
          fontWeight: fontWeight,
          fill: "#444",
          lineHeight: 1.5,
        });

        converText.controls = {
          ...fabric.IText.prototype.controls,
          mtr: new fabric.Control({ visible: false }),
        };
        converText.set({
          transparentCorners: false,
          cornerColor: "#6c63ff",
          cornerStrokeColor: "#6c63ff",
          borderColor: "#6c63ff",
          selectionLineWidth: 10,
          cornerSize: 10,
          cornerStyle: "circle",
        });

        current.add(converText);
        current.setActiveObject(converText);
        converText.selectAll();
        converText.enterEditing();
        converText.hiddenTextarea.focus();
        current.renderAll();
        return false;
      } else {
        console.log("check");
      }
    });
  };
  const pagePicture = (e, page) => {
    var imageName = e.target.files[0].name.replace(/\s+/g, "-").toLowerCase();
    setLoading(true);
    var formdata = new FormData();
    formdata.append("file", e.target.files[0], imageName);
    var requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow",
      credentials: "include",
    };

    fetch(
      `${process.env.REACT_APP_BASE_URL}mfb/rest/book/upload_photo`,
      requestOptions
    )
      .then((response) => response.text())
      .then((image) => {
        console.log("data", image);
        setLoading(false);
        fabric.Image.fromURL(image, function (imageURL) {
          var setImage = imageURL.set({
            left: 60,
            top: 200,
          });
          setImage.scaleToWidth(500);
          canvasInstances.forEach(function (current) {
            if (current.page === page) {
              current.add(setImage);
            }
          });
        });
      })
      .catch((error) => {
        console.log("error", error);
        notification["error"]({
          message: "Maximum upload size 3MB",
        });
      });
  };

  // === Save canvas start ===
  const saveCanvas = () => {
    const userID = localStorage.getItem("UserID");
    console.log(canvasInstances);

    var allpages = [];
    canvasInstances.forEach(function (current, index) {
      current.page = current.page;
      current.canvasID = index;
      var json = current.toJSON(["page", "canvasID"]);
      var jsonString = JSON.stringify(json);
      allpages.push(jsonString);
    });

    const formData = {
      coverPage: "string",
      name: canvasInstances[0].item(0).text
        ? canvasInstances[0].item(0).text
        : "My First Book",
      pages: allpages,
      userId: userID,
      id: id,
    };
    console.log(formData);
    //return false;
    axios({
      method: "PUT",
      url: `${process.env.REACT_APP_BASE_URL}mfb/rest/book/book`,
      data: formData,
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
      withCredentials: true,
    })
      .then((res) => {
        console.log("res", res);
        if (res.status == 200) {
          notification["success"]({
            message: "Saved Successfully",
          });
          console.log("res", res);
        }
      })
      .catch(function (error) {
        notification["error"]({
          message: "Error",
        });
      });
  };
  // === Save canvas end ===

  // ======= Canvas painting start ========
  const [textColor, setTextColor] = useState("#444");
  const changeTextColor = (e) => {
    setTextColor(e);
    console.log("textcolor", canvasInstances);
    canvasInstances.forEach(function (current) {
      if (current.getActiveObject()) {
        var currentElement = current.getActiveObject();
        currentElement.setSelectionStyles({ fill: e });
        current.renderAll();
      } else {
        console.log("error");
      }
    });
  };
  const changeFontFamily = (value) => {
    canvasInstances.forEach(function (current) {
      if (current.getActiveObject()) {
        var currentElement = current.getActiveObject();
        currentElement.set("fontFamily", value);
        current.renderAll();
      }
    });
  };
  const changeBgCoverColor = (e, page) => {
    console.log("here", canvasInstances);
    canvasInstances.forEach(function (current, index) {
      if (current.page === page) {
        current.backgroundColor = e;
        current.renderAll();
      }
    });
  };
  const changeFontSize = (value) => {
    canvasInstances.forEach(function (current) {
      if (current.getActiveObject()) {
        var currentElement = current.getActiveObject();
        currentElement.set("fontSize", value);
        console.log(value);
        current.renderAll();
      }
    });
  };
  // ======= Canvas painting End ========
  const exportPdf = () => {
    var forPDF = document.querySelectorAll(".canvas-container");
    var len = forPDF.length;

    var thisPDF = new jsPDF("landscape", "mm", [222, 157]); //210mm wide and 297mm high

    forPDF.forEach((element, i) => {
      html2canvas(element, { allowTaint: true, useCORS: true }).then(
        (canvas) => {
          thisPDF.addImage(
            canvas.toDataURL("images/png", 1),
            "JPG",
            0,
            0,
            222,
            157
          );
          if (parseInt(i + 1) == parseInt(len)) {
            thisPDF.save("sample-file.pdf");
          } else {
            thisPDF.addPage();
          }
        }
      );
    });
  };
  const menu = (
    <Menu>
      <Menu.Item key="0">
        <Link to="/Mybooks">My Books</Link>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="1" onClick={createNewBook}>
        Create New Book
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="2" onClick={exportPdf}>
        Download in PDF
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="3">
        <Logout />
      </Menu.Item>
    </Menu>
  );

  return (
    <div className="dashboard">
      <header className="navbar-header">
        <div className="home-logo">
          <img src={logo} alt="" />
          <h3>My First Book</h3>
        </div>

        <div className="home-action">
          <div className="btn-group">
            <button onClick={() => deleteItem()} className="btn btn-border">
              Delete
            </button>
            <button className="btn btn-theme" onClick={saveCanvas}>
              Save
            </button>

            <Dropdown overlay={menu} trigger={["click"]}>
              <div className="user-avator">
                <UserOutlined />
              </div>
            </Dropdown>
          </div>
        </div>
      </header>
      <div className="side-nav">
        <Tabs defaultActiveKey="1" tabPosition="left">
          <TabPane
            tab={
              <span>
                <img width="25" src={coverIcon} alt="" /> <br />
                Cover Page
              </span>
            }
            key="1"
          >
            <div className="book-content">
              <Collapse defaultActiveKey={["1"]} bordered={false} accordion>
                <Panel header="Cover Content" key="1">
                  <div
                    className="add-element"
                    onClick={() =>
                      addBookContent(
                        "Cover Title",
                        "cover",
                        400,
                        40,
                        700,
                        300,
                        60
                      )
                    }
                  >
                    <h3>Add Book Title</h3>
                  </div>
                  <div
                    className="add-element"
                    onClick={() =>
                      addBookContent(
                        "Type Name",
                        "cover",
                        100,
                        25,
                        400,
                        20,
                        500
                      )
                    }
                  >
                    <h3>Add Name</h3>
                  </div>
                  <div
                    className="add-element"
                    onClick={() =>
                      addBookContent(
                        "Type Age",
                        "cover",
                        100,
                        25,
                        400,
                        150,
                        500
                      )
                    }
                  >
                    <h3>Add Age</h3>
                  </div>
                  <div
                    className="add-element"
                    onClick={() =>
                      addBookContent(
                        "Type Birthday",
                        "cover",
                        200,
                        25,
                        400,
                        260,
                        500
                      )
                    }
                  >
                    <h3>Add Birthday</h3>
                  </div>
                  <label className="custom-upload">
                    Upload Picture
                    <input
                      type="file"
                      accept="image/png, image/gif, image/jpeg"
                      onChange={(e) => pagePicture(e, "cover")}
                    />
                  </label>
                </Panel>
                <Panel header="Cover Design" key="2">
                  <div>
                    <h3>Page Background</h3>
                    <div className="default-colors">
                      <span
                        style={{ backgroundColor: "#66ffff" }}
                        onClick={() => changeBgCoverColor("#66ffff", "cover")}
                      />
                      <span
                        style={{ backgroundColor: "#b6e7f6" }}
                        onClick={() => changeBgCoverColor("#b6e7f6", "cover")}
                      />
                      <span
                        style={{ backgroundColor: "#ffffcc" }}
                        onClick={() => changeBgCoverColor("#ffffcc", "cover")}
                      />
                      <span
                        style={{ backgroundColor: "#fcf" }}
                        onClick={() => changeBgCoverColor("#fcf", "cover")}
                      />
                      <span
                        style={{ backgroundColor: "#f9c" }}
                        onClick={() => changeBgCoverColor("#f9c", "cover")}
                      />

                      <span
                        style={{ backgroundColor: "#fff" }}
                        onClick={() => changeBgCoverColor("#fff", "cover")}
                      />
                    </div>
                    <Divider dashed />
                    <h3>Text Color</h3>
                    <div className="action-style">
                      <PopoverPicker
                        color={textColor}
                        onChange={changeTextColor}
                      />
                    </div>
                    <h3>Font Family</h3>
                    <div className="action-style">
                      <Select
                        placeholder="Select Font Family"
                        onChange={changeFontFamily}
                        className="fullwidth"
                      >
                        <Option value="Baloo 2">Baloo 2</Option>
                        <Option value="Roboto, sans-serif">Roboto</Option>
                        <Option value="Verdana, sans-serif">Verdana</Option>
                        <Option value="Tahoma, sans-serif">Tahoma</Option>
                        <Option value="Trebuchet MS, sans-serif">
                          Trebuchet MS
                        </Option>
                        <Option value="Impact, sans-serif">Impact</Option>
                        <Option value="Times New Roman, sans-serif">
                          Times New Roman
                        </Option>
                        <Option value="Didot, sans-serif">Didot</Option>
                        <Option value="Georgia, sans-serif">Georgia</Option>
                        <Option value="American Typewriter, sans-serif">
                          American Typewriter
                        </Option>
                        <Option value="Courier, sans-serif">Courier</Option>
                        <Option value="Comic Sans MS, sans-serif">
                          Comic Sans MS
                        </Option>
                      </Select>
                    </div>
                    <h3>Font Size</h3>
                    <div className="action-style">
                      <Select
                        placeholder="Select Font Size"
                        onChange={changeFontSize}
                        className="fullwidth"
                      >
                        <Option value="14">14</Option>
                        <Option value="15">16</Option>
                        <Option value="18">18</Option>
                        <Option value="20">20</Option>
                        <Option value="25">25</Option>
                        <Option value="30">30</Option>
                        <Option value="35">35</Option>
                        <Option value="40">40</Option>
                        <Option value="45">45</Option>
                        <Option value="50">50</Option>
                        <Option value="60">60</Option>
                        <Option value="70">70</Option>
                      </Select>
                    </div>
                  </div>
                </Panel>
              </Collapse>
            </div>
          </TabPane>
          <TabPane
            tab={
              <span>
                <img width="30" src={bookIcon} alt="" /> <br />
                Book Design
              </span>
            }
            key="2"
          >
            <div className="book-content">
              <Collapse defaultActiveKey={["1"]} bordered={false} accordion>
                <Panel header="Book Content Pages" key="1">
                  <div className="inner-collapse">
                    <Collapse bordered={false} accordion>
                      <Panel header="Primary Care Giver" key="1">
                        <div className="create-page">
                          <Switch
                            defaultChecked={isPrimaryPage}
                            onChange={(e) => createCanvas(e, "primary")}
                            checkedChildren="Remove Page"
                            unCheckedChildren="Create Page"
                          />
                        </div>
                        <div
                          className="add-element"
                          onClick={() =>
                            addBookContent(
                              "Primary Care Giver",
                              "primary",
                              400,
                              40,
                              700,
                              100,
                              60
                            )
                          }
                        >
                          <h3>Page Title</h3>
                        </div>
                        <div
                          className="add-element"
                          onClick={() =>
                            addBookContent(
                              "Description",
                              "primary",
                              500,
                              25,
                              400,
                              60,
                              130
                            )
                          }
                        >
                          <h3>Description</h3>
                        </div>
                        <label className="custom-upload">
                          Upload Picture
                          <input
                            type="file"
                            accept="image/png, image/gif, image/jpeg"
                            onChange={(e) => pagePicture(e, "primary")}
                          />
                        </label>
                      </Panel>
                      <Panel header="Siblings/Others" key="2">
                        <div className="create-page">
                          <Switch
                            defaultChecked={isSiblingsPage}
                            onChange={(e) => createCanvas(e, "siblings")}
                            checkedChildren="Remove Page"
                            unCheckedChildren="Create Page"
                          />
                        </div>
                        <div
                          className="add-element"
                          onClick={() =>
                            addBookContent(
                              "Siblings/Others",
                              "siblings",
                              400,
                              30,
                              700,
                              100,
                              60
                            )
                          }
                        >
                          <h3>Page Title</h3>
                        </div>
                        <div
                          className="add-element"
                          onClick={() =>
                            addBookContent(
                              "Description",
                              "siblings",
                              500,
                              25,
                              400,
                              60,
                              100
                            )
                          }
                        >
                          <h3>Description</h3>
                        </div>
                        <label className="custom-upload">
                          Upload Picture
                          <input
                            type="file"
                            accept="image/png, image/gif, image/jpeg"
                            onChange={(e) => pagePicture(e, "siblings")}
                          />
                        </label>
                      </Panel>
                      <Panel header="My Things" key="3">
                        <div className="create-page">
                          <Switch
                            defaultChecked={isThingsPage}
                            onChange={(e) => createCanvas(e, "things")}
                            checkedChildren="Remove Page"
                            unCheckedChildren="Create Page"
                          />
                        </div>
                        <div
                          className="add-element"
                          onClick={() =>
                            addBookContent(
                              "My Things",
                              "things",
                              400,
                              30,
                              700,
                              100,
                              60
                            )
                          }
                        >
                          <h3>Page Title</h3>
                        </div>
                        <div
                          className="add-element"
                          onClick={() =>
                            addBookContent(
                              "Description",
                              "things",
                              500,
                              25,
                              400,
                              60,
                              100
                            )
                          }
                        >
                          <h3>Description</h3>
                        </div>
                        <label className="custom-upload">
                          Upload Picture
                          <input
                            type="file"
                            accept="image/png, image/gif, image/jpeg"
                            onChange={(e) => pagePicture(e, "things")}
                          />
                        </label>
                      </Panel>
                      <Panel header="My Food" key="4">
                        <div className="create-page">
                          <Switch
                            defaultChecked={isFoodPage}
                            onChange={(e) => createCanvas(e, "food")}
                            checkedChildren="Remove Page"
                            unCheckedChildren="Create Page"
                          />
                        </div>
                        <div
                          className="add-element"
                          onClick={() =>
                            addBookContent(
                              "My Food",
                              "food",
                              400,
                              30,
                              700,
                              100,
                              60
                            )
                          }
                        >
                          <h3>Page Title</h3>
                        </div>
                        <div
                          className="add-element"
                          onClick={() =>
                            addBookContent(
                              "Description",
                              "food",
                              500,
                              25,
                              400,
                              60,
                              100
                            )
                          }
                        >
                          <h3>Description</h3>
                        </div>
                        <label className="custom-upload">
                          Upload Picture
                          <input
                            type="file"
                            accept="image/png, image/gif, image/jpeg"
                            onChange={(e) => pagePicture(e, "things")}
                          />
                        </label>
                      </Panel>
                      <Panel header="My Drinks" key="5">
                        <div className="create-page">
                          <Switch
                            defaultChecked={isDrinksPage}
                            onChange={(e) => createCanvas(e, "drinks")}
                            checkedChildren="Remove Page"
                            unCheckedChildren="Create Page"
                          />
                        </div>
                        <div
                          className="add-element"
                          onClick={() =>
                            addBookContent(
                              "My Drinks",
                              "drinks",
                              400,
                              30,
                              700,
                              100,
                              60
                            )
                          }
                        >
                          <h3>Page Title</h3>
                        </div>
                        <div
                          className="add-element"
                          onClick={() =>
                            addBookContent(
                              "Description",
                              "drinks",
                              500,
                              25,
                              400,
                              60,
                              100
                            )
                          }
                        >
                          <h3>Description</h3>
                        </div>
                        <label className="custom-upload">
                          Upload Picture
                          <input
                            type="file"
                            accept="image/png, image/gif, image/jpeg"
                            onChange={(e) => pagePicture(e, "drinks")}
                          />
                        </label>
                      </Panel>
                      <Panel header="My Toys" key="6">
                        <div className="create-page">
                          <Switch
                            defaultChecked={isToysPage}
                            onChange={(e) => createCanvas(e, "toys")}
                            checkedChildren="Remove Page"
                            unCheckedChildren="Create Page"
                          />
                        </div>
                        <div
                          className="add-element"
                          onClick={() =>
                            addBookContent(
                              "My Toys",
                              "toys",
                              400,
                              30,
                              700,
                              100,
                              60
                            )
                          }
                        >
                          <h3>Page Title</h3>
                        </div>
                        <div
                          className="add-element"
                          onClick={() =>
                            addBookContent(
                              "Description",
                              "toys",
                              500,
                              25,
                              400,
                              60,
                              100
                            )
                          }
                        >
                          <h3>Description</h3>
                        </div>
                        <label className="custom-upload">
                          Upload Picture
                          <input
                            type="file"
                            accept="image/png, image/gif, image/jpeg"
                            onChange={(e) => pagePicture(e, "toys")}
                          />
                        </label>
                      </Panel>
                      <Panel header="I Like to Watch" key="7">
                        <div className="create-page">
                          <Switch
                            defaultChecked={isWatchPage}
                            onChange={(e) => createCanvas(e, "watch")}
                            checkedChildren="Remove Page"
                            unCheckedChildren="Create Page"
                          />
                        </div>
                        <div
                          className="add-element"
                          onClick={() =>
                            addBookContent(
                              "I Like to Watch",
                              "watch",
                              400,
                              30,
                              700,
                              100,
                              60
                            )
                          }
                        >
                          <h3>Page Title</h3>
                        </div>
                        <div
                          className="add-element"
                          onClick={() =>
                            addBookContent(
                              "Description",
                              "watch",
                              500,
                              25,
                              400,
                              60,
                              100
                            )
                          }
                        >
                          <h3>Description</h3>
                        </div>
                        <label className="custom-upload">
                          Upload Picture
                          <input
                            type="file"
                            accept="image/png, image/gif, image/jpeg"
                            onChange={(e) => pagePicture(e, "watch")}
                          />
                        </label>
                      </Panel>
                      <Panel header="My Rooms" key="8">
                        <div className="create-page">
                          <Switch
                            defaultChecked={isRoomsPage}
                            onChange={(e) => createCanvas(e, "rooms")}
                            checkedChildren="Remove Page"
                            unCheckedChildren="Create Page"
                          />
                        </div>
                        <div
                          className="add-element"
                          onClick={() =>
                            addBookContent(
                              "My Rooms",
                              "rooms",
                              400,
                              30,
                              700,
                              100,
                              60
                            )
                          }
                        >
                          <h3>Page Title</h3>
                        </div>
                        <div
                          className="add-element"
                          onClick={() =>
                            addBookContent(
                              "Description",
                              "rooms",
                              500,
                              25,
                              400,
                              60,
                              100
                            )
                          }
                        >
                          <h3>Description</h3>
                        </div>
                        <label className="custom-upload">
                          Upload Picture
                          <input
                            type="file"
                            accept="image/png, image/gif, image/jpeg"
                            onChange={(e) => pagePicture(e, "rooms")}
                          />
                        </label>
                      </Panel>
                      <Panel header="My Bedroom" key="9">
                        <div className="create-page">
                          <Switch
                            defaultChecked={isBedroomPage}
                            onChange={(e) => createCanvas(e, "bedroom")}
                            checkedChildren="Remove Page"
                            unCheckedChildren="Create Page"
                          />
                        </div>
                        <div
                          className="add-element"
                          onClick={() =>
                            addBookContent(
                              "My Bedroom",
                              "bedroom",
                              400,
                              30,
                              700,
                              100,
                              60
                            )
                          }
                        >
                          <h3>Page Title</h3>
                        </div>
                        <div
                          className="add-element"
                          onClick={() =>
                            addBookContent(
                              "Description",
                              "bedroom",
                              500,
                              25,
                              400,
                              60,
                              100
                            )
                          }
                        >
                          <h3>Description</h3>
                        </div>
                        <label className="custom-upload">
                          Upload Picture
                          <input
                            type="file"
                            accept="image/png, image/gif, image/jpeg"
                            onChange={(e) => pagePicture(e, "bedroom")}
                          />
                        </label>
                      </Panel>
                      <Panel header="Living Room" key="10">
                        <div className="create-page">
                          <Switch
                            defaultChecked={isLivingPage}
                            onChange={(e) => createCanvas(e, "living")}
                            checkedChildren="Remove Page"
                            unCheckedChildren="Create Page"
                          />
                        </div>
                        <div
                          className="add-element"
                          onClick={() =>
                            addBookContent(
                              "Living Room",
                              "living",
                              400,
                              30,
                              700,
                              100,
                              60
                            )
                          }
                        >
                          <h3>Page Title</h3>
                        </div>
                        <div
                          className="add-element"
                          onClick={() =>
                            addBookContent(
                              "Description",
                              "living",
                              500,
                              25,
                              400,
                              60,
                              100
                            )
                          }
                        >
                          <h3>Description</h3>
                        </div>
                        <label className="custom-upload">
                          Upload Picture
                          <input
                            type="file"
                            accept="image/png, image/gif, image/jpeg"
                            onChange={(e) => pagePicture(e, "living")}
                          />
                        </label>
                      </Panel>
                      <Panel header="My Home" key="11">
                        <div className="create-page">
                          <Switch
                            defaultChecked={isHomePage}
                            onChange={(e) => createCanvas(e, "home")}
                            checkedChildren="Remove Page"
                            unCheckedChildren="Create Page"
                          />
                        </div>
                        <div
                          className="add-element"
                          onClick={() =>
                            addBookContent(
                              "My Home",
                              "home",
                              400,
                              30,
                              700,
                              100,
                              60
                            )
                          }
                        >
                          <h3>Page Title</h3>
                        </div>
                        <div
                          className="add-element"
                          onClick={() =>
                            addBookContent(
                              "Description",
                              "home",
                              500,
                              25,
                              400,
                              60,
                              100
                            )
                          }
                        >
                          <h3>Description</h3>
                        </div>
                        <label className="custom-upload">
                          Upload Picture
                          <input
                            type="file"
                            accept="image/png, image/gif, image/jpeg"
                            onChange={(e) => pagePicture(e, "home")}
                          />
                        </label>
                      </Panel>
                      <Panel header="My Places" key="12">
                        <div className="create-page">
                          <Switch
                            defaultChecked={isPlacesPage}
                            onChange={(e) => createCanvas(e, "places")}
                            checkedChildren="Remove Page"
                            unCheckedChildren="Create Page"
                          />
                        </div>
                        <div
                          className="add-element"
                          onClick={() =>
                            addBookContent(
                              "My Places",
                              "places",
                              400,
                              30,
                              700,
                              100,
                              60
                            )
                          }
                        >
                          <h3>Page Title</h3>
                        </div>
                        <div
                          className="add-element"
                          onClick={() =>
                            addBookContent(
                              "Description",
                              "places",
                              500,
                              25,
                              400,
                              60,
                              100
                            )
                          }
                        >
                          <h3>Description</h3>
                        </div>
                        <label className="custom-upload">
                          Upload Picture
                          <input
                            type="file"
                            accept="image/png, image/gif, image/jpeg"
                            onChange={(e) => pagePicture(e, "places")}
                          />
                        </label>
                      </Panel>
                      <Panel header="My Friends" key="13">
                        <div className="create-page">
                          <Switch
                            defaultChecked={isFriendsPage}
                            onChange={(e) => createCanvas(e, "friends")}
                            checkedChildren="Remove Page"
                            unCheckedChildren="Create Page"
                          />
                        </div>
                        <div
                          className="add-element"
                          onClick={() =>
                            addBookContent(
                              "My Friends",
                              "friends",
                              400,
                              30,
                              700,
                              100,
                              60
                            )
                          }
                        >
                          <h3>Page Title</h3>
                        </div>
                        <div
                          className="add-element"
                          onClick={() =>
                            addBookContent(
                              "Description",
                              "friends",
                              500,
                              25,
                              400,
                              60,
                              100
                            )
                          }
                        >
                          <h3>Description</h3>
                        </div>
                        <label className="custom-upload">
                          Upload Picture
                          <input
                            type="file"
                            accept="image/png, image/gif, image/jpeg"
                            onChange={(e) => pagePicture(e, "friends")}
                          />
                        </label>
                      </Panel>
                      <Panel header="Child interest" key="15">
                        <div className="create-page">
                          <Switch
                            defaultChecked={isInterestPage}
                            onChange={(e) => createCanvas(e, "interest")}
                            checkedChildren="Remove Page"
                            unCheckedChildren="Create Page"
                          />
                        </div>
                        <div
                          className="add-element"
                          onClick={() =>
                            addBookContent(
                              "Child interest",
                              "interest",
                              400,
                              30,
                              700,
                              100,
                              60
                            )
                          }
                        >
                          <h3>Page Title</h3>
                        </div>
                        <div
                          className="add-element"
                          onClick={() =>
                            addBookContent(
                              "Description",
                              "interest",
                              500,
                              25,
                              400,
                              60,
                              100
                            )
                          }
                        >
                          <h3>Description</h3>
                        </div>
                        <label className="custom-upload">
                          Upload Picture
                          <input
                            type="file"
                            accept="image/png, image/gif, image/jpeg"
                            onChange={(e) => pagePicture(e, "interest")}
                          />
                        </label>
                      </Panel>
                    </Collapse>
                  </div>
                </Panel>
                <Panel header="Book Design" key="2">
                  <div>
                    <h3>Text Color</h3>
                    <div className="action-style">
                      <PopoverPicker
                        color={textColor}
                        onChange={changeTextColor}
                      />
                    </div>
                    <h3>Font Family</h3>
                    <div className="action-style">
                      <Select
                        placeholder="Select Font Family"
                        onChange={changeFontFamily}
                        className="fullwidth"
                      >
                        <Option value="Baloo 2">Baloo 2</Option>
                        <Option value="Roboto, sans-serif">Roboto</Option>
                        <Option value="Verdana, sans-serif">Verdana</Option>
                        <Option value="Tahoma, sans-serif">Tahoma</Option>
                        <Option value="Trebuchet MS, sans-serif">
                          Trebuchet MS
                        </Option>
                        <Option value="Impact, sans-serif">Impact</Option>
                        <Option value="Times New Roman, sans-serif">
                          Times New Roman
                        </Option>
                        <Option value="Didot, sans-serif">Didot</Option>
                        <Option value="Georgia, sans-serif">Georgia</Option>
                        <Option value="American Typewriter, sans-serif">
                          American Typewriter
                        </Option>
                        <Option value="Courier, sans-serif">Courier</Option>
                        <Option value="Comic Sans MS, sans-serif">
                          Comic Sans MS
                        </Option>
                      </Select>
                    </div>
                    <h3>Font Size</h3>
                    <div className="action-style">
                      <Select
                        placeholder="Select Font Size"
                        onChange={changeFontSize}
                        className="fullwidth"
                      >
                        <Option value="14">14</Option>
                        <Option value="15">16</Option>
                        <Option value="18">18</Option>
                        <Option value="20">20</Option>
                        <Option value="25">25</Option>
                        <Option value="30">30</Option>
                        <Option value="35">35</Option>
                        <Option value="40">40</Option>
                        <Option value="45">45</Option>
                        <Option value="50">50</Option>
                        <Option value="60">60</Option>
                        <Option value="70">70</Option>
                      </Select>
                    </div>
                  </div>
                </Panel>
              </Collapse>
            </div>
          </TabPane>
        </Tabs>
      </div>
      <div className="main-content">
        <Spin tip="Loading..." spinning={loading}>
          <div className="canvas-section">
            <div className="canvas-wrap" id="canvasContainer"></div>
          </div>
        </Spin>
      </div>
    </div>
  );
};
export default Book;
